import {
  SET_LISTING_SECTIONS,
  SET_LISTING_SECTIONS_IS_LOADING,
  SET_SECTIONS_LOADING,
} from '../constants/sectionsConstants';

export const listingSectionInitialState = {
  sectionsByOrder: {},
  isLoading: true,
  isSectionsLoading: true,
};

const listinSectionsReducer = (state = listingSectionInitialState, action) => {
  switch (action.type) {
    case SET_LISTING_SECTIONS:
      return {
        ...state,
        sectionsByOrder: {
          ...state.sectionsByOrder,
          ...action.payload,
        },
      };
    case SET_LISTING_SECTIONS_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_SECTIONS_LOADING:
      return {
        ...state,
        isSectionsLoading: action.payload,
      };
    default:
      return state;
  }
};

export default listinSectionsReducer;
